import makeLevel from '../makeLevel.js';
import * as powerups from '../../powerups.js';

export default makeLevel([
	'!!!!!!!!!!!!!!!!!!!!',
	'*******************!',
	'*******************!',
	'!!!!!!!!!!!!!!!!!!!!',
	'!*******************',
	'!*******************',
	'!!!!!!!!!!!!!!!!!!!!',
	'*******************!',
	'*******************!',
	'!!!!!!!!!!!!!!!!!!!!',
	'!*******************',
	'!*******************',
	'!*******************',
	'!!!!!!!!!!!!!!!!!!!!',
	'*******************!',
	'*******************!',
	'!!!!!!!!!!!!!!!!!!!!',
	'!*******************',
	'!*******************',
	'!!!!!!!!!!!!!!!!!!!!',
], [
    {
        "2": powerups.weakenBlocks,
        "5": powerups.ballUnstopable,
        "13": powerups.ballSpeedDown,
        "14": powerups.paddleSticky,
        "29": powerups.ballSpeedUp,
        "32": powerups.ballUnstopable,
        "33": powerups.ballSpeedUp,
        "35": powerups.paddleGrow,
        "58": powerups.paddleShrink,
        "69": powerups.ballSpeedUp,
        "71": powerups.paddleGrow,
        "76": powerups.paddleLasers,
        "81": powerups.paddleGrow,
        "101": powerups.paddleGrow,
        "104": powerups.instaDeath,
        "112": powerups.ballExtra,
        "113": powerups.ballExtra,
        "115": powerups.paddleShrink,
        "116": powerups.ballSpeedDown,
        "118": powerups.ballSpeedDown,
        "119": powerups.ballSpeedUp,
        "124": powerups.paddleShrink,
        "125": powerups.paddleGrow,
        "135": powerups.ballExploding,
        "144": powerups.paddleShrink,
        "145": powerups.paddleShrink,
        "149": powerups.ballUnstopable,
        "160": powerups.paddleGrow,
        "161": powerups.paddleShrink,
        "163": powerups.ballSpeedUp,
        "166": powerups.paddleGrow,
        "177": powerups.instaDeath,
        "179": powerups.paddleGrow,
        "186": powerups.ballExtra,
        "193": powerups.ballExtra,
        "203": powerups.paddleShrink,
        "206": powerups.paddleShrink,
        "210": powerups.ballExploding,
        "216": powerups.ballSpeedUp,
        "217": powerups.ballExtra,
        "218": powerups.ballSpeedDown,
        "241": powerups.skipLevel,
        "242": powerups.paddleSticky,
        "253": powerups.paddleMini,
        "254": powerups.paddleShrink,
        "257": powerups.ballUnstopable,
        "260": powerups.ballExtra,
        "265": powerups.ballExtra,
        "273": powerups.paddleSticky,
        "277": powerups.ballExploding,
        "278": powerups.paddleLasers,
        "283": powerups.ballExploding,
        "287": powerups.ballUnstopable,
        "290": powerups.ballExtra,
        "292": powerups.ballSpeedUp,
        "295": powerups.ballSpeedUp,
        "296": powerups.paddleShrink,
        "301": powerups.paddleLasers,
        "302": powerups.ballSpeedUp,
        "315": powerups.ballSpeedUp,
        "317": powerups.ballUnstopable,
        "319": powerups.ballUnstopable,
        "324": powerups.ballExtra,
        "325": powerups.weakenBlocks,
        "331": powerups.ballSpeedDown,
        "336": powerups.paddleMini,
        "342": powerups.paddleSticky,
        "348": powerups.ballSpeedUp,
        "352": powerups.ballSpeedDown,
        "360": powerups.paddleGrow,
        "370": powerups.paddleGrow,
        "380": powerups.paddleMini,
        "382": powerups.weakenBlocks,
        "383": powerups.paddleLasers,
        "384": powerups.paddleShrink,
        "399": powerups.ballSpeedUp
    },
    {
        "14": powerups.ballExtra,
        "17": powerups.paddleShrink,
        "23": powerups.paddleSticky,
        "29": powerups.paddleGrow,
        "30": powerups.ballExtra,
        "31": powerups.paddleShrink,
        "44": powerups.paddleSticky,
        "46": powerups.ballSpeedUp,
        "49": powerups.ballExploding,
        "50": powerups.ballSpeedDown,
        "59": powerups.paddleShrink,
        "63": powerups.ballExtra,
        "69": powerups.ballExtra,
        "81": powerups.ballSpeedUp,
        "84": powerups.ballExploding,
        "96": powerups.ballExtra,
        "100": powerups.ballExtra,
        "107": powerups.paddleGrow,
        "110": powerups.paddleGrow,
        "115": powerups.paddleSticky,
        "124": powerups.ballExploding,
        "135": powerups.ballUnstopable,
        "146": powerups.ballSpeedDown,
        "149": powerups.ballExploding,
        "152": powerups.ballExtra,
        "153": powerups.ballSpeedDown,
        "161": powerups.ballUnstopable,
        "169": powerups.ballSpeedDown,
        "170": powerups.paddleMini,
        "172": powerups.ballSpeedDown,
        "180": powerups.paddleShrink,
        "184": powerups.paddleGrow,
        "186": powerups.weakenBlocks,
        "199": powerups.ballSpeedUp,
        "202": powerups.instaDeath,
        "206": powerups.paddleGrow,
        "214": powerups.paddleGrow,
        "217": powerups.ballExploding,
        "219": powerups.paddleGrow,
        "222": powerups.ballExtra,
        "226": powerups.ballExploding,
        "227": powerups.lightning,
        "231": powerups.ballSpeedUp,
        "233": powerups.ballExtra,
        "234": powerups.paddleGrow,
        "242": powerups.ballSpeedUp,
        "243": powerups.paddleShrink,
        "250": powerups.weakenBlocks,
        "258": powerups.paddleMini,
        "263": powerups.paddleLasers,
        "269": powerups.paddleSticky,
        "284": powerups.ballUnstopable,
        "286": powerups.paddleGrow,
        "291": powerups.paddleLasers,
        "295": powerups.weakenBlocks,
        "296": powerups.ballExtra,
        "300": powerups.paddleGrow,
        "314": powerups.paddleLasers,
        "341": powerups.paddleGrow,
        "365": powerups.paddleShrink,
        "367": powerups.paddleLasers,
        "383": powerups.paddleGrow,
        "393": powerups.skipLevel
    },
    {
        "2": powerups.paddleLasers,
        "4": powerups.paddleLasers,
        "6": powerups.ballSpeedUp,
        "7": powerups.ballSpeedUp,
        "14": powerups.ballSpeedUp,
        "15": powerups.paddleLasers,
        "22": powerups.ballSpeedDown,
        "41": powerups.paddleShrink,
        "48": powerups.paddleGrow,
        "57": powerups.ballExtra,
        "60": powerups.paddleShrink,
        "67": powerups.paddleLasers,
        "71": powerups.instaDeath,
        "84": powerups.paddleShrink,
        "87": powerups.ballExploding,
        "97": powerups.ballUnstopable,
        "100": powerups.ballExploding,
        "105": powerups.ballExtra,
        "132": powerups.paddleMini,
        "146": powerups.ballExploding,
        "148": powerups.instaDeath,
        "155": powerups.paddleSticky,
        "160": powerups.ballSpeedDown,
        "162": powerups.ballExtra,
        "169": powerups.paddleSticky,
        "170": powerups.weakenBlocks,
        "177": powerups.ballSpeedDown,
        "179": powerups.paddleShrink,
        "183": powerups.ballSpeedUp,
        "189": powerups.ballExtra,
        "199": powerups.ballUnstopable,
        "205": powerups.ballExtra,
        "207": powerups.paddleGrow,
        "210": powerups.ballExtra,
        "216": powerups.ballSpeedDown,
        "218": powerups.instaDeath,
        "220": powerups.paddleShrink,
        "221": powerups.paddleSticky,
        "243": powerups.ballSpeedUp,
        "245": powerups.ballSpeedUp,
        "246": powerups.paddleGrow,
        "250": powerups.ballSpeedUp,
        "253": powerups.paddleLasers,
        "254": powerups.paddleMini,
        "261": powerups.paddleShrink,
        "262": powerups.paddleShrink,
        "269": powerups.ballSpeedUp,
        "273": powerups.ballSpeedDown,
        "277": powerups.lightning,
        "281": powerups.ballExtra,
        "283": powerups.ballSpeedUp,
        "285": powerups.lightning,
        "286": powerups.paddleLasers,
        "298": powerups.ballUnstopable,
        "300": powerups.paddleShrink,
        "302": powerups.ballUnstopable,
        "303": powerups.paddleMini,
        "307": powerups.ballSpeedUp,
        "309": powerups.ballExtra,
        "310": powerups.paddleLasers,
        "313": powerups.paddleSticky,
        "315": powerups.paddleShrink,
        "319": powerups.ballSpeedDown,
        "320": powerups.ballExtra,
        "334": powerups.paddleGrow,
        "335": powerups.ballSpeedDown,
        "336": powerups.ballSpeedUp,
        "340": powerups.ballSpeedDown,
        "357": powerups.paddleGrow,
        "359": powerups.paddleLasers,
        "362": powerups.ballExtra,
        "372": powerups.paddleSticky,
        "377": powerups.ballSpeedDown,
        "395": powerups.paddleGrow,
        "399": powerups.ballExtra
    },
    {
        "2": powerups.ballUnstopable,
        "10": powerups.ballSpeedDown,
        "22": powerups.ballExploding,
        "30": powerups.lightning,
        "33": powerups.ballExploding,
        "34": powerups.paddleLasers,
        "35": powerups.ballSpeedUp,
        "42": powerups.ballSpeedDown,
        "51": powerups.ballSpeedDown,
        "53": powerups.paddleShrink,
        "58": powerups.paddleSticky,
        "80": powerups.ballSpeedDown,
        "81": powerups.ballUnstopable,
        "82": powerups.ballExploding,
        "87": powerups.ballExtra,
        "88": powerups.paddleSticky,
        "89": powerups.paddleGrow,
        "92": powerups.instaDeath,
        "94": powerups.paddleGrow,
        "105": powerups.ballSpeedUp,
        "108": powerups.ballSpeedUp,
        "114": powerups.paddleLasers,
        "119": powerups.paddleGrow,
        "121": powerups.ballExploding,
        "123": powerups.ballSpeedUp,
        "131": powerups.paddleGrow,
        "132": powerups.paddleShrink,
        "136": powerups.paddleLasers,
        "137": powerups.paddleGrow,
        "139": powerups.paddleGrow,
        "145": powerups.ballSpeedDown,
        "149": powerups.ballSpeedUp,
        "150": powerups.skipLevel,
        "153": powerups.ballExploding,
        "154": powerups.ballSpeedDown,
        "155": powerups.instaDeath,
        "159": powerups.paddleShrink,
        "161": powerups.paddleShrink,
        "170": powerups.lightning,
        "173": powerups.paddleGrow,
        "175": powerups.ballSpeedDown,
        "180": powerups.ballExploding,
        "186": powerups.paddleSticky,
        "187": powerups.ballExtra,
        "190": powerups.weakenBlocks,
        "196": powerups.paddleSticky,
        "198": powerups.paddleShrink,
        "199": powerups.paddleShrink,
        "204": powerups.paddleShrink,
        "208": powerups.ballExtra,
        "217": powerups.ballExploding,
        "220": powerups.paddleShrink,
        "221": powerups.ballExtra,
        "236": powerups.paddleShrink,
        "240": powerups.ballSpeedUp,
        "259": powerups.paddleGrow,
        "260": powerups.ballSpeedUp,
        "273": powerups.ballExtra,
        "278": powerups.paddleShrink,
        "280": powerups.ballSpeedUp,
        "286": powerups.ballSpeedUp,
        "292": powerups.ballSpeedDown,
        "300": powerups.paddleShrink,
        "306": powerups.paddleGrow,
        "308": powerups.paddleShrink,
        "312": powerups.paddleSticky,
        "320": powerups.ballSpeedUp,
        "325": powerups.paddleLasers,
        "332": powerups.ballSpeedUp,
        "344": powerups.weakenBlocks,
        "349": powerups.paddleShrink,
        "351": powerups.ballUnstopable,
        "355": powerups.ballExtra,
        "364": powerups.paddleGrow,
        "365": powerups.paddleLasers,
        "373": powerups.paddleShrink,
        "377": powerups.ballSpeedUp,
        "380": powerups.ballExtra,
        "386": powerups.paddleGrow,
        "392": powerups.paddleSticky,
        "393": powerups.paddleSticky,
        "395": powerups.lightning,
        "396": powerups.paddleLasers
    }
]);
